import { TmrBaseResource } from 'stylewhere/api'

export class ItemConfigurations extends TmrBaseResource {
  static endpoint = '/api/v1/itemConfigurations'
}
